module.exports = __webpack_public_path__ + "media/images/log/log-graph-tohoku-e801ad8c678c6cc25e13666283d5b191.svg";